import { genericConfigEnabledCheck } from './addons-config-adapter-common';
// Internal Config
// Client Config when Remote Config is disabled
export function adaptConvivaClientConfig() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _defaultConfig_config, _clientConfig_config, _clientConfig_config1, _clientConfig_config2, _clientConfig_config3, _clientConfig_config4, _clientConfig_config5;
    var _config_defaultConfig = config.defaultConfig, defaultConfig = _config_defaultConfig === void 0 ? {} : _config_defaultConfig, _config_clientConfig = config.clientConfig, clientConfig = _config_clientConfig === void 0 ? {} : _config_clientConfig;
    var isEnabled = Boolean(clientConfig.enabled);
    return {
        enabled: isEnabled,
        config: {
            // Default config values
            shouldReportChipsetWithModel: (_defaultConfig_config = defaultConfig.config) === null || _defaultConfig_config === void 0 ? void 0 : _defaultConfig_config.shouldReportChipsetWithModel,
            // Client config values
            heartbeatInterval: (_clientConfig_config = clientConfig.config) === null || _clientConfig_config === void 0 ? void 0 : _clientConfig_config.heartbeatInterval,
            mutedErrorCodes: (_clientConfig_config1 = clientConfig.config) === null || _clientConfig_config1 === void 0 ? void 0 : _clientConfig_config1.mutedErrorCodes,
            enableAdInsights: (_clientConfig_config2 = clientConfig.config) === null || _clientConfig_config2 === void 0 ? void 0 : _clientConfig_config2.enableAdInsights,
            customerKey: (_clientConfig_config3 = clientConfig.config) === null || _clientConfig_config3 === void 0 ? void 0 : _clientConfig_config3.customerKey,
            gatewayUrl: (_clientConfig_config4 = clientConfig.config) === null || _clientConfig_config4 === void 0 ? void 0 : _clientConfig_config4.gatewayUrl,
            isDebug: (_clientConfig_config5 = clientConfig.config) === null || _clientConfig_config5 === void 0 ? void 0 : _clientConfig_config5.isDebug
        }
    };
}
// Server Config when Remote Config is enabled
// Client Config when Remote Config is enabled
export function adaptConvivaRemoteConfigSplit(config) {
    var requiredFields = {
        customerKey: null,
        gatewayUrl: null
    };
    var isEnabled = genericConfigEnabledCheck(config, requiredFields, 'Conviva');
    if (!isEnabled) {
        return;
    }
    var clientConfig = config.clientConfig, remoteConfig = config.remoteConfig;
    return {
        enabled: isEnabled,
        config: {
            heartbeatInterval: remoteConfig.config.heartbeatInterval,
            mutedErrorCodes: remoteConfig.config.mutedErrorCodes,
            enableAdInsights: remoteConfig.config.enableAdInsights,
            shouldReportChipsetWithModel: remoteConfig.config.shouldReportChipsetWithModel,
            customerKey: clientConfig.customerKey,
            gatewayUrl: clientConfig.gatewayUrl,
            isDebug: clientConfig.isDebug
        }
    };
}

//# sourceMappingURL=conviva-config-adapter.js.map